import { postProducerRequest } from './request'

export default {
  postProducerRequest
}
